import { jsx } from "react/jsx-runtime";
import CreditScoreIcon from "@mui/icons-material/CreditScore";
import { validateTidalLicense } from "../../base/index.js";
function CreditScore(props) {
  return /* @__PURE__ */ jsx(
    CreditScoreIcon,
    {
      "data-testid": "CreditScore",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "CreditScore",
      "data-tidal-icon-meta": "money,invoices,payments"
    }
  );
}
CreditScore.tidalIconMeta = {
  categories: "money,invoices,payments",
  name: "CreditScore"
};
validateTidalLicense();
export {
  CreditScore
};
//# sourceMappingURL=CreditScore.js.map
